import * as React from 'react'
import { IconName } from '../../../lib/constants'
import { Icon } from '../Icon'
import { NavigationLink } from '../NavigationLink'
import { Container, Group, IconWrapper, LinkWrapper, NavList, Text, Wrapper } from './styled'
import { SubnavigationProps } from './types'
import styled from 'styled-components'

export const Subnavigation = ({ children }: SubnavigationProps) => {
  return (
    <Wrapper>
      <Container>
        <NavList>{children}</NavList>
      </Container>
    </Wrapper>
  )
}

const HoverWrapper = styled.div`
  align-items: center;
  display: flex;
  padding: 0.25rem;
  gap: 0.5rem;
  // border-radius: 0.5rem;
  // color: ${({ theme }) => theme.colors.black[1]};
  // outline: 0 solid transparent;
  // text-decoration: none;
  // transition: background-color 0.2s ease-in-out, outline 0.2s ease-in-out;
  // user-select: none;

  // &:hover {
  //   background-color: ${({ theme }) => theme.colors.black[6]};

  //   ${IconWrapper} {
  //     background-color: ${({ theme }) => theme.colors.white[1]};
  //   }
  }
`


export const SubnavigationGroup = Group
export const SubnavigationLink = ({
  as,
  children,
  isActive,
  useTheme,
  icon,
  isFullWidth,
  ...rest
}: {
  as?: React.ElementType
  children: React.ReactNode
  isActive?: boolean
  useTheme?: boolean
  icon?: IconName
  isFullWidth?: boolean
  [key: string]: any
}) => {
  return (
    <LinkWrapper>
      <NavigationLink
        activeClassName="active"
        isActive={isActive}
        useTheme={useTheme}
        as={as}
        isFullwidth={isFullWidth}
        {...rest}
      >
        <HoverWrapper>
          {icon && (
            <IconWrapper>
              <Icon name={icon} iconSize=".9rem" />
            </IconWrapper>
          )}
          <Text>{children}</Text>
        </HoverWrapper>
      </NavigationLink>
    </LinkWrapper>
  )
}
